import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';

import { GenerateStarDataPipe } from './generate-star-data.pipe';
import { HotelPriceTransformerPipe } from './hotel-price-transformer.pipe';
import { HotelCancellationTransformerPipe } from './hotel-cancelattion-transformer.pipe';

import { AuthService } from 'src/app/core/services/auth.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';
import { FavoritesProviderService } from 'src/app/core/services/favorites-provider.service';

export interface IHotelItem {
  accommodation_type_id: string;
  address: string;
  city: string;
  country_code: string;
  deep_link_url: string;
  description: string;
  email: string;
  fax: string;
  hotel_id: string;
  id: string;
  image: {
    ThumbnailUrl: string;
    title: string;
    type: string;
    url: string;
  };
  important_info: string;
  latitude: string;
  longitude: string;
  name: string;
  phone: string;
  providerDeepLink: string;
  providerMobileDeepLink: string;
  rating: {
    count: string;
    average: string;
  };
  url: string;
  zip: string;
  type: string;

  class?: 'highlight' | 'not-highlight';
  mealPlan?: 'no_plan' | 'breakfast_included';
  cancellation?: any[];
  providerURL?: string;
  price?: {
    amount: number;
    baseAmount: number;
    currency: 'EUR';
    totalAmount: number;
  };
  stars?: number;
}

@Component({
  selector: 'app-booking-hotel-card',
  templateUrl: './booking-hotel-card.component.html',
  styleUrl: './booking-hotel-card.component.scss',
  imports: [
    MatIconModule,
    GenerateStarDataPipe,
    HotelCancellationTransformerPipe,
    HotelPriceTransformerPipe,
    NgxSkeletonLoaderModule,
  ],
})
export class BookingHotelCardComponent {
  @Input() cityId: number;
  @Input({ required: true }) countryName: string;
  @Input({ required: true }) cityName: string;
  @Input({ required: true }) hotelData: IHotelItem;
  @Input() isFetching: boolean = false;

  @Output() onUnFavourite = new EventEmitter<void>();

  protected readonly eSvgIcons = ESvgIcons;
  protected readonly favoritesProviderService: FavoritesProviderService =
    inject(FavoritesProviderService);
  protected readonly googleAnalyticService: GoogleAnalyticService = inject(
    GoogleAnalyticService,
  );
  protected readonly authService: AuthService = inject(AuthService);

  toggleHurt(e: Event, hotel: IHotelItem): void {
    e.preventDefault();
    e.stopPropagation();

    this.favoritesProviderService.checkUserAuth(
      {
        favoriteId: hotel.id.toString(),
        placeId: Number(this.cityId),
        provider: 'booking.com',
      },
      hotel,
      this.cityName,
      (isDelete) => {
        if (isDelete) this.onUnFavourite.emit();
        if (!isDelete) {
          this.googleAnalyticService.setAddToWishlistAnalytic({
            whishlist_category: 'hotels',
            merchant: 'booking',
            service_country: this.countryName,
            service_city: this.cityName,
            category_name: 'hotels: ${hotel.name}',
            service_title: `hotels: ${hotel.name}`,
            userID: this.authService.userId,
          });
        }
      },
    );
  }

  public trackAndRedirect(event: Event, url: string): void {
    event.preventDefault();
    event.stopPropagation();
    this.setGoogleAnalytic();

    setTimeout(() => {
      window.open(url, '_blank');
    }, 250);
  }

  private setGoogleAnalytic() {
    this.googleAnalyticService.setHotelAnalytic({
      activityName: this.hotelData.name,
      activityType: this.hotelData?.type,
      countryName: this.countryName,
      cityName: this.cityName,
      userID: this.authService.userId,
    });
  }
}
